/*
 * @Author: Roman
 * @Date: 2022-11-08 13:54:27
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2023-01-08 14:15:08
 * @FilePath: \qpmn-site\src\app\modules\store\store-product\rest\store-product-rest.service.ts
 * @Description: 
 */
import { AbstractAccessorService } from "@core/data-access";
import type { IDataAccessor } from "@core/data-access";
import type { IStatesFlowRestService } from "./states-flow-rest";
import type { IResponse } from "@core/data-access/model";
import { StateInstanceDTO } from "@modules/common/model/domain/stateFlow/StateInstanceDTO";
import { StateInstanceDetail } from "@modules/common/model/domain/stateFlow/StateInstanceDetail";
import { ReturnRequestOrderExpressDto } from "@modules/order/model/dto/ReturnRequestOrderExpressDto";
import { State } from "@modules/common/model/domain/stateFlow/State";
import { StoreProduct } from "@modules/store/store-product/model/domain/store-product";
import { Environment } from "@env/Environment";
import { envConfig } from "@env/env-config";

export class StatesFlowRestService extends AbstractAccessorService<StoreProduct> implements IStatesFlowRestService {
    public readonly $name: string = "StatesFlowRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<StoreProduct>) {
        super();
    }

    public getBranch(endityId: string): angular.IPromise<IResponse<Array<StateInstanceDTO>>> {
        return this.$accessor<Array<StateInstanceDTO>, { endityId: string }, string>(this.$name, "getBranch", {
            parameter: {
                endityId: endityId
            }
        });
    }

    public getBranched(endityId: string): angular.IPromise<IResponse<Array<StateInstanceDetail>>> {
        return this.$accessor<Array<StateInstanceDetail>, { endityId: string }, string>(this.$name, "getBranched", {
            parameter: {
                endityId: endityId
            }
        });
    }
    public cancel(endityId: string): angular.IPromise<IResponse<any>> {
        let _requestConfig = {
            data: {
                endityId: endityId,
                actionKey: envConfig.ActionKey.cancelReturn
            }
        }
        return this.$accessor<any, { endityId: string }, string>(this.$name, "cancel", _requestConfig);
    }
    public submitExpress(endityId: string, express: ReturnRequestOrderExpressDto): angular.IPromise<IResponse<any>> {
        let _requestConfig = {
            parameter: {
                endityId: endityId
            },
            data: {
                data: {
                    // endityId: endityId,
                    number: express.number,
                    provider: express.provider,
                    returnRequestOrder: {
                        _id: endityId
                    },
                    clazz: "com.qpp.cgp.domain.salesreturn.ReturnRequestOrderExpress",
                },
                actionKey: envConfig.ActionKey.expressAction
            }
        }
        return this.$accessor<any, any, string>(this.$name, "submitExpress", _requestConfig);
    }
    public getStateNodes(): angular.IPromise<IResponse<Array<State>>> {
        return this.$accessor<Array<State>, {}, string>(this.$name, "getStateNodes");
    }
}
